/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PromoTokenType,
    PromoTokenTypeFromJSON,
    PromoTokenTypeFromJSONTyped,
    PromoTokenTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface PromoTokenBody
 */
export interface PromoTokenBody {
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    description?: string;
    /**
     * 
     * @type {PromoTokenType}
     * @memberof PromoTokenBody
     */
    type: PromoTokenType;
    /**
     * 
     * @type {boolean}
     * @memberof PromoTokenBody
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoTokenBody
     */
    isBranded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    targetUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromoTokenBody
     */
    couponCodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PromoTokenBody
     */
    qrImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PromoTokenBody
     */
    expiresAt?: number;
    /**
     * 
     * @type {number}
     * @memberof PromoTokenBody
     */
    maxLimit?: number;
}

export function PromoTokenBodyFromJSON(json: any): PromoTokenBody {
    return PromoTokenBodyFromJSONTyped(json, false);
}

export function PromoTokenBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromoTokenBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': PromoTokenTypeFromJSON(json['type']),
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'isBranded': !exists(json, 'isBranded') ? undefined : json['isBranded'],
        'targetUrl': !exists(json, 'targetUrl') ? undefined : json['targetUrl'],
        'couponCodes': !exists(json, 'couponCodes') ? undefined : json['couponCodes'],
        'qrImageUrl': !exists(json, 'qrImageUrl') ? undefined : json['qrImageUrl'],
        'expiresAt': !exists(json, 'expiresAt') ? undefined : json['expiresAt'],
        'maxLimit': !exists(json, 'maxLimit') ? undefined : json['maxLimit'],
    };
}

export function PromoTokenBodyToJSON(value?: PromoTokenBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'type': PromoTokenTypeToJSON(value.type),
        'isEnabled': value.isEnabled,
        'isBranded': value.isBranded,
        'targetUrl': value.targetUrl,
        'couponCodes': value.couponCodes,
        'qrImageUrl': value.qrImageUrl,
        'expiresAt': value.expiresAt,
        'maxLimit': value.maxLimit,
    };
}


